/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.

  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
 ******************************************************************************************************************** */
/** @jsxImportSource @emotion/react */
import StatusIndicator from '@cloudscape-design/components/status-indicator';
import { css } from '@emotion/react';
import { FC } from 'react';

const styles = css({
  background: 'transparent',
  border: 'none !important',
  cursor: 'pointer',
});

export interface StatusProps {
  completed?: boolean;
  label: string;
  onClick: () => void;
}

const Status: FC<StatusProps> = ({ completed, label, onClick }) => {
  return (<button css={styles} onClick={onClick}><StatusIndicator type={completed ? 'success' : 'stopped'}>{label}</StatusIndicator></button>);
};

export default Status;
